import type { TenantConfig } from '@/types/TenantConfig'

export const sloomoo: TenantConfig = {
  logo: 'assets/sloomoo/static/logo.png',
  teaserImageSize: {
    width: 500,
    height: 500,
  },
  titleInsideContentColumn: true,
  componentOptions: {
    checkoutRoute: {
      stripeWallets: true,
    },
    eventDetailRoute: {
      singleTicketEventCategories: [],
      // quantityFirst: true,
    },
    cartWidget: {
      dateTimeFormat: 'ddd, D MMM @ h:mm A',
    },

    stripeCreditCard: {
      fontFaceStylesheet: 'https://fonts.googleapis.com/css?family=Quicksand:400,500,600,700&display=swap',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/sloomoo/static/complete-wide.jpg',
        mobile: 'assets/sloomoo/static/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-144px',
        mobile: '-96px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Checkout',
      },
      cartWidget: {
        fixedFees: 'Administration Fee',
        percentFees: 'Sales Tax',
      },
      termsModal: {
        title: 'Release and Waiver of Liability',
      },
    },
  },
}
